import { Comment } from "./comment";
import { plateHistory } from "./plateHistory"

export class Sample{
    _id:string;
    sampleID:string;
    position:string;
    sampleType:string;
    assignedSampleType: string;
    selectedSampleType: string;
    beadChipID:string;
    beadChipPosition:string;
    redoBeadChipID:string;
    redoBeadChipPosition:string;
    redoBeadChipRedoReason:string;
    singleRedo:boolean;
    plateRedo:boolean;
    toBePicked:boolean;
    activated: boolean;
    gender: string;
    comments: Comment[];
    color: string;
    topBarcode: string;
    bottomBarcode: string;
    sourcePlateID?: string;
    projectID?: string;
    boxID?:string;
    boxReceptionTimeStamp?: Date;
    status?:string;
    storage?:boolean;
    announced?: boolean;
    reProcessed: boolean;
    sampleUpdated?: boolean;
    plateHistory?: plateHistory[];
    receptionDateTime? : Date;
    barCode? : string;
    receptionStatus?: string;
    receptionPUID?: string;
    sourcePlatePosition?: string = "";
    callRate?:number;
    qcCallRate?:number;
    dqc?:number;
    computedGender?:string;
    evaluationResult?:string;
    presentInCellFile?: boolean;
    scanDate?: Date;
    priority?:number
    autoRerun?: boolean = false;
    reRunCount?: number = 0;
    icbfSampleID? : number;
    qcSampleHistory?:any[];
    dueDate?:Date;
    plateDueDate?:Date;
    processed?: boolean;
    plated?:boolean;
    sampleCompletionDate!:Date;
    animalNumber:string;
    ittNumber:string;
    announcedDate:Date;
    receptionIssueReason:string;
    isRedoSample:boolean;
    mintSampleID: string;
    parentMintSampleID:string;
    parentSampleID:string;
}
